export function normalizeRouteCity(value) {
  if (value == null) return "";
  if (typeof value === "object") {
    return String(value.text || value.value || value.label || "").trim();
  }
  return String(value).trim();
}

export function normalizeRouteVias(vias) {
  if (!Array.isArray(vias)) return [];
  return vias
    .map((via) => normalizeRouteCity(via))
    .filter((via) => via.length > 0);
}

export function formatRouteVias(vias) {
  const normalized = normalizeRouteVias(vias);
  return normalized.length ? normalized.join(" → ") : "—";
}

export function defaultRouteLabel(cityStart, cityEnd) {
  const start = normalizeRouteCity(cityStart);
  const end = normalizeRouteCity(cityEnd);
  if (!start && !end) return "";
  if (!start) return end;
  if (!end) return start;
  return `${start} - ${end}`;
}

export function formatRouteLabel(route) {
  if (!route) return "";
  const label = String(route.label || "").trim();
  if (label) return label;
  return defaultRouteLabel(route.city_start, route.city_end);
}

export function sortRoutesForPicker(routes) {
  return [...(routes || [])].sort((a, b) => {
    const labelCmp = formatRouteLabel(a).localeCompare(formatRouteLabel(b), undefined, {
      sensitivity: "base",
    });
    if (labelCmp !== 0) return labelCmp;
    const aVias = normalizeRouteVias(a.vias);
    const bVias = normalizeRouteVias(b.vias);
    if (aVias.length === 0 && bVias.length > 0) return -1;
    if (bVias.length === 0 && aVias.length > 0) return 1;
    const viaCmp = formatRouteVias(aVias).localeCompare(formatRouteVias(bVias), undefined, {
      sensitivity: "base",
    });
    if (viaCmp !== 0) return viaCmp;
    return String(a.description || "").localeCompare(String(b.description || ""), undefined, {
      sensitivity: "base",
    });
  });
}

export default {
  normalizeRouteCity,
  normalizeRouteVias,
  formatRouteVias,
  defaultRouteLabel,
  formatRouteLabel,
  sortRoutesForPicker,
};
